// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/menu_itens/delete/{id}
 *
 * Confirms deletion of a menu item.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MenuItens_DeleteResponseDados {
message: string
}

export type MenuItens_DeleteResponse = ApiResponse<MenuItens_DeleteResponseDados>;

registerResponseContract('MenuItens_DeleteResponse', {
  message: { type: 'string',  required: true },
})
